import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Modal} from 'semantic-ui-react';
import {createPayment} from '../../../redux/actions/payment';

function PaymentModal(props) {
  return (
    <Modal
      closeIcon
      closeOnEscape={false}
      closeOnDimmerClick={false}
      open={props.open}
      onClose={props.onClose}
      size={props.size}
    >
      <Modal.Header>افزایش اعتبار</Modal.Header>
      <Modal.Content>
        <div>{props.content}</div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          positive
          size='large'
          content={` افزایش اعتبار به مبلغ ${props.amount.toLocaleString()} ریال`}
          onClick={pay.bind(null, props.createPayment, props.orderId, props.amount)}
        />
        <Button
          negative
          size='large'
          content='خروج'
          onClick={props.onClose}
        />
      </Modal.Actions>
    </Modal>
  );
}

async function pay(createPayment, orderId, amount) {
  const {payload: {url}} = await createPayment(orderId, amount);
  window.location.replace(url);
}

function mapStateToProps(state) {
  return {userCredit: state.user.data.credit};
}

PaymentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  content: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
  orderId: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
  createPayment: PropTypes.func.isRequired
};

PaymentModal.defaultProps = {size: 'large'};

export default connect(mapStateToProps, {createPayment})(PaymentModal);
